import styled, { css } from 'styled-components'

type Size = 'small' | 'medium' | 'large'
type Variant = 'primary' | 'secondary'

const sizeStylesMap: Record<Size, ReturnType<typeof css>> = {
  small: css`
    font-size: var(--font-size-200);
    line-height: var(--font-line-height-200);
    letter-spacing: var(--font-letter-spacing-normal);
    gap: var(--space-150);
  `,
  medium: css`
    font-size: var(--font-size-300);
    line-height: var(--font-line-height-300);
    letter-spacing: var(--font-letter-spacing-loose);
    gap: var(--space-200);
  `,
  large: css`
    font-size: var(--font-size-400);
    line-height: var(--font-line-height-400);
    letter-spacing: var(--font-letter-spacing-normal);
    gap: var(--space-200);
  `,
}

const variantStylesMap: Record<Variant, ReturnType<typeof css>> = {
  primary: css`
    color: var(--text-secondary);

    &:hover,
    &:active {
      color: var(--text-primary);
    }
  `,
  secondary: css`
    color: var(--text-brand);

    &:hover,
    &:active {
      color: var(--text-brand-secondary);
    }
  `,
}

export const Container = styled.button<{
  $size: Size
  $variant: Variant
  disabled?: boolean
}>`
  width: 100%;
  display: inline-flex;
  align-items: center;
  cursor: pointer;

  ${({ $size }) => sizeStylesMap[$size]};
  ${({ $variant }) => variantStylesMap[$variant]};

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
      opacity: 0.5;
    `}
`
